export default "__VITE_ASSET__B2o6PepW__"